import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ParameterCreateUpdate from "./create-update";
import { RoleItem } from "../../../models/types/role";
import rolesSvc from "../../../services/api/roles";
import Loading from "../../../components/loading/loading";

export default function RolesCreateUpdatePage() {
    const { id } = useParams<{ id?: string }>();

    const isCreate = !id;
    const [data, setData] = useState<RoleItem | null>(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (id) {
            setLoading(true);
            rolesSvc.getRoleById(id).then((res) => {
                setData(res.content);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [id]);
    return (
        <div className="page-wrapper h-full">
            {loading ? <Loading /> : <ParameterCreateUpdate isCreate={isCreate} data={data} />}
        </div>
    );
}